import { css } from 'styled-components'
import { media } from './media'

export const scaleAnimation = css`
  /* animation only on desktop */
  ${media.desktop} {
    &:hover {
      transform: scale(1.02);
    }

    &:focus {
      transform: scale(1.02);
    }
  }
`
